import { UsergroupAddOutlined, UserAddOutlined, UserOutlined, ShopOutlined } from '@ant-design/icons';

const model = {
  loading: false,
  details: {},
  cardData: [
    {
      name: 'Total Users',
      icon: UsergroupAddOutlined,
      id: 'totalUsers',
      value: 0
    },
    {
      name: 'New Users',
      icon: UserAddOutlined,
      id: 'newUsers',
      value: 0
    },
    {
      name: 'Companies',
      icon: ShopOutlined,
      id: 'companies',
      value: 0
    },
    {
      name: 'Individuals',
      icon: UserOutlined,
      id: 'individuals',
      value: 0
    },
  ],
  globals: {
    locations: [],
    stakeholders: [],
    scl: [],
    scp: [],
    lir: [],
    administrativeLevel1: [],
    administrativeLevel2: [],
    administrativeLevel3: [],
    administrativeLevel4: [],
    administrativeLevel5: [],
    administrativeLevel6: [],
    administrativeLevel7: [],
    administrativeLevel8: [],
    administrativeLevel9: [],
    administrativeLevel10: [],
  },
};

export default model;
